module.exports = __webpack_public_path__ + "static/media/ticket-on.cbeda9ff.svg";